import 'intl-tel-input'

export const getDialCodeForCountry = (countryCode) => {
  if (!countryCode) return null
  const getCountryData = window.intlTelInputGlobals?.getCountryData
  if (!getCountryData) return null
  const country = getCountryData().find(
    (c) => c.iso2 === countryCode.toLowerCase()
  )
  return country ? `+${country.dialCode}` : null
}

export const isDialCodeOnly = (value, countryCode) => {
  return value === '+' || value === getDialCodeForCountry(countryCode)
}
